<template>
  <div
    class="rprincipal mb-2"
    v-if="userInsData.loading === false && isLoading === false"
  >
    <div class="row" v-if="dogTarifas !== null && debugTabla">
      <div class="col-md-12">{{ icClass.calcularImporteTotal() }}</div>
    </div>
    <div v-for="(drazas, n) in dogs" :key="n * 25">
      <div class="card mb-1">
        <div class="card-header">
          <b>{{ razaNombre(n) }}</b>
        </div>
        <div
          class="card-body border-bottom p-2"
          v-for="dog in drazas"
          :key="dog.id"
        >
        <!--   {{ inscriptonDogData(dog.id) }} -->
          <div class="row">
            <!-- nombre | sexo | fecha nacimiento -->
            <div class="col-8 mr-0 pr-0">
              <div class="w-100 h6">{{ dog.name }} </div>
            </div>
            <!-- selector de clase -->
            <div class="col-4 ml-0 pl-0">
              <select
                v-model="dog.class_selected"
                class="ml-0 float-right w-100"
                :class="{ seleccionado: dog.class_selected !== null }"
                @change="asignarTarifa({ id: dog.class_selected, dog: dog })"
              >
                <option :value="null">{{ $t("seleccionar") }}</option>
                <option
                  v-for="clase in dog.clases"
                  :key="`${dog.id}_${clase.id}`"
                  :value="clase.id"
                  >{{ $t(clase.class) }}</option
                >
              </select>
            </div>
          </div>
          <!-- ./row -->
          <div class="row">
            <div class="col-8">            
              <small>                  
                {{dog.chip}},
                {{ getSexo(dog.id) }},&nbsp;
                {{ dog.birth }}<!-- ,&nbsp; Edad en
                meses :
                {{ dog.edad }} -->
              </small>
            </div>
            <div class="col-4">
              <div class="w-100 text-right" v-if="!!dog.class_selected && !!inscriptonDogData(dog.id) ">
                ({{ inscriptonDogData(dog.id).posicion }})
                <b>{{ importePerro(dog.id).toFixed(2) }} €</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

 <!--    <div class="row" v-if="dogs !== null">
      <ins-dog-doc-rq
        v-if="dog.class_selected !== null"
        :datosDog="dog"
        :tarifa="inscriptonDogData(dog.id)"
      ></ins-dog-doc-rq>
      <ins-dog-detail
        v-if="dog.class_selected !== null"
        :datosDog="dog"
        :tarifa="inscriptonDogData(dog.id)"
      ></ins-dog-detail>
    </div>

    <div class="row" v-else>
      <p class="text-center">{{ $t("no tiene perros resgistrados") }}</p>
    </div> -->

    <div style="font-size:11px;" v-if="debugTabla">
      <table class="table" v-if="dogTarifas !== null">
        <thead>
          <tr>
            <th>dogid</th>
            <th>tarifaid</th>
            <th>clase</th>
            <th>precio</th>
            <th>filtrosAplicados</th>
            <th>descuentos</th>
            <th>grupoPrecio</th>
            <th>posicion</th>
            <th>precioAplicado</th>
            <th>hayCopropietarios</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="dognorm in datosNormalizados" :key="dognorm.dogId">
            <td>{{ dognorm.dogId }}</td>
            <td>{{ dognorm.tarifaId }}</td>
            <td>{{ dognorm.clase }}</td>
            <td>{{ dognorm.precio }}</td>
            <td>{{ dognorm.filtrosAplicados }}</td>
            <td>{{ dognorm.descuentos }}</td>
            <td>{{ dognorm.grupoPrecio }}</td>
            <td>{{ dognorm.posicion }}</td>
            <td>{{ dognorm.precioAplicado }}</td>
            <td>{{ dognorm.hayCopropietarios }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row" v-if="dogTarifas !== null && debugTabla">
      {{ icClass.calcularImporteTotal() }}
    </div>

<!--          <fab
          :position="fab.position"
          :bg-color="fab.bgColor"
          :actions="fab.fabActions"
          :icon-size="fab.size"
          @cache="alert('cache')"
          @alertMe="alert('hola')"
          main-tooltip="reset"
        >hola</fab> -->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import InscriptionsCalcs from "@/_helpers/inscriptions-class";
import InsDogDetail from "./Inscriptions-dog-detail";
import InsDogDocRq from "./Inscriptions-doc-required-comp";
import fab from "vue-fab";
import _ from "lodash";

export default {
  name: "inscriptions-doglist-comp",
  props: ["expoData", "socio", "parentInscripciones", "datosNormalizados"],
  components: { InsDogDetail, InsDogDocRq, fab },
  data: () => ({
    debugTabla: false,
    isLoading: true,
    dogs: null,
    icClass: null,
    dogTarifas: null,
    fab: {
     bgColor: "#C00B3D",
      position: "bottom-right",
      size: "large",
      fabActions: [
        {
          color: "red",
          name: "cache",
          icon: "cached"
        },
        {
          name: "alertMe",
          icon: "add_alert"
        }
      ],
    }
  }),
  methods: {
    /* funcion para mostrar el nombre de la raza dada su id */
    razaNombre(razaId) {
        
        const raza = this.expoData.breeds_all.find(b => b.id === parseInt(razaId)).translations;
        const lang = this.$i18n.locale;        
        const tmp = raza.find(r => r.locale === lang);
        let res = tmp.name;
        if (tmp.variety !== "" ) res += ' ' + tmp.variety;
        if (tmp.subvariety !== "" ) res += ' ' + tmp.subvariety; 
        return res;
    },  
    /* extrae el precio del precio y lo mustro por pantalla */
    importePerro(dogId) {
      const tarifa = this.inscriptonDogData(dogId);
      if (!tarifa) return 0;     

      return this.socio === 0
        ? tarifa.precio.price
        : tarifa.precio.price_partner;
    },

    emitInscripciones() {
      this.$emit("emitInscripciones", { inscripciones: this.dogTarifas });
    },
    getSexo(dogId) {
      const dog =this.userInsData.data.dogs.find(d => d.id === dogId);
      const tmpSex = parseInt(dog.sex_id) === 1 ? "macho" : "hembra";
      return this.$t(tmpSex);
    },   
    /* Método para asignar una tarifa a un perro o eliminarla y recalcular */
    asignarTarifa(data) {
      //si devolvemos un id null eliminamos el registro que hemos pasado a null y recalculamos esa tarifa
      if (data.id === null) {
        const dataDogEligibles = this.dogs;
        this.icClass.eliminarPerroInscripciones(data.dog).then(res => {
          //si devuelvo un obj es que hay más perros que recalcular
          //act 22-11-2019 se recalculan en la clase... y nos devuelve
          console.log("promesa eliminar perro inscripciones", res);
          if (res !== true) {
            //al eliminar el perro de las inscripciones nos devuelve las tarifas recalculadas
            this.dogTarifas = res;
          }
        });
        this.emitInscripciones();
        return;
      } else {
        //primero comprobamos si ya lo tenemos registrado en una tarifa....por si es un cambio
        if (this.checkExisteDogEnAlguaTarifa(data.dog)) {
          //  console.log("existe en alguna tarifa", data.id)
          this.icClass
            .eliminarPerroInscripciones(data.dog)
            .then(res => {
              //     console.log("eliminarPerroInscripciones", res);
              this.dogTarifas = res;
              return res;
            })
            .then(() => {
              this.icClass
                .generarTarifa2(data.id, data.dog, this.socio)
                .then(res => {
                  this.dogTarifas = this.icClass.getInscripciones();
                  this.emitInscripciones();
                });
            });
        } else {
          //si no lo temeos registrado lo registramos
          this.icClass
            .generarTarifa2(data.id, data.dog, this.socio)
            .then(res => {
              this.dogTarifas = this.icClass.getInscripciones();
              this.icClass.getInscripcionesNormalizadas();
              this.emitInscripciones();
            });
        }
      }
    },
    /* Método para seleccionar los datos de inscripción de un perro y enviarlos al detalle */
    inscriptonDogData(dogId) {
      if (this.dogTarifas === null) {
        return null;
      }
      for (let i = 0; i < this.dogTarifas.length; i++) {
        const tarifa = this.dogTarifas[i];
        const dogData = tarifa.dogs.filter(
          x => parseInt(x.id) === parseInt(dogId)
        );
        if (dogData.length > 0) {
          return dogData[0];
        }
      }
    },

    /* Método para comprobar si un perro ya existe en una tarifa y ha cambiado a otra */
    checkExisteDogEnAlguaTarifa(dog) {
      if (this.dogTarifas === null) {
        return false;
      }
      //  console.log("checkExisteDogEnAlguaTarifa", this.dogTarifas);
      const existe = this.dogTarifas.filter(x => {
        if (
          x.dogs.filter(c => {
            c.id === dog.id;
          })
        ) {
          return x;
        }
      });
      // console.log("existe->", existe.length);
      return existe.length > 0;
    }
  },
  computed: {
    ...mapState("inscription", ["userInsData"])
  },

  mounted() {
    const salida = iniciarInscripcion(
      this.userInsData.data,
      this.expoData,
      this.parentInscripciones,
      this.socio
    );
    this.icClass = salida.class;
    console.log(this.expoData, this.userInsData.data)
    //console.log(_.groupBy(_.sortBy(salida.dogs, "breed_id"), "breed_id"));
    this.dogs = _.groupBy(_.sortBy(salida.dogs, "breed_id"), "breed_id");
    this.dogTarifas = this.parentInscripciones;
    setTimeout(() => {
      this.isLoading = false;
    }, 150);
  },
  beforeDestroy() {
    console.log("destruido...desde inscrip-dogs-comp");
  }
};

function iniciarInscripcion(
  userData,
  expoData,
  parentInscripciones,
  socio = 0
) {
  let salida = new InscriptionsCalcs(
    userData,
    expoData,
    parentInscripciones,
    socio
  );
  const tmpDogs = salida.generarListaDePerrosEligibles();

  let dogs = tmpDogs.sort(function(a, b) {
    const edadA = parseFloat(a.edad);
    const edadB = parseFloat(b.edad);
    if (edadA > edadB) {
      return 1;
    }
    if (edadA < edadB) {
      return -1;
    }
    return 0;
  });

  if (parentInscripciones !== null && dogs.length > 0) {
    //asignamos a cada perro su tarifa
    for (let i = 0; i < parentInscripciones.length; i++) {
      const element = parentInscripciones[i].dogs;
      for (let j = 0; j < element.length; j++) {
        const el = element[j];
        let dog = dogs.filter(x => {
          if (parseInt(x.id) === parseInt(el.id)) return x;
        });
        if (dog.length === 1) {
          dog[0].class_selected = el.clase;
        }
      }
    }
  }
  return { class: salida, dogs: dogs };
}
</script>

<style scoped>
select {
  height: 35px !important;
  padding: 5px 10px 5px 10px;
}
.seleccionado {
  background-color: #28a745;
  color: white;
}
</style>
